import { useQuery, useMutation, useInfiniteQuery } from "react-query";
import { SubscriptionsService } from "./subscriptions.service";
import toast from "react-hot-toast";

const getErrorMessage = (error: any) => {
  return error?.msg || error?.message || String(error);
};

// GET List
const useGetList = (page: number, option?: Object) => {
  return useQuery(
    ["listSubscriptions", page, option],
    async () => {
      const { data } = await SubscriptionsService.getListSubscriptions({
        page,
        ...option,
      });
      return data;
    },
    { keepPreviousData: true },
  );
};

const usePayment = (cb?: (data: any) => void) => {
  return useMutation(
    async (idItem: string) => {
      const data = await SubscriptionsService.createPayment(idItem);
      return data;
    },
    {
      onSuccess: (data) => {
        cb?.(data);
        if (data.ok) {
          toast.success("Create successfully!");
        } else {
          toast.error(data?.msg);
        }
      },
      onError(error) {
        alert(error);
      },
    },
  );
};

// DELETE Detail
const useActive = (cb?: (data: any) => void) => {
  return useMutation(
    async (idItem: string) => {
      const data = await SubscriptionsService.active(idItem);
      return data;
    },
    {
      onSuccess: (data) => {
        cb?.(data);
        if (data.ok) {
          toast.success("Active successfully!");
        } else {
          toast.error(data?.msg);
        }
      },
      onError(error) {
        alert(error);
      },
    },
  );
};

const useDeActive = (cb?: (data: any) => void) => {
  return useMutation(
    async (idItem: string) => {
      const data = await SubscriptionsService.deActive(idItem);
      return data;
    },
    {
      onSuccess: (data) => {
        cb?.(data);
        if (data.ok) {
          toast.success("Action successfully!");
        } else {
          toast.error(data?.msg);
        }
      },
      onError(error) {
        alert(error);
      },
    },
  );
};

// DELETE
const useDelete = (cb?: (data: any) => void) => {
  return useMutation(
    async (idSubscription: string) => {
      const data =
        await SubscriptionsService.deleteSubscription(idSubscription);
      return data;
    },
    {
      onSuccess: (data) => {
        cb?.(data);
        if (data.ok) {
          toast.success("Delete success!");
        } else {
          toast.error(data?.msg);
        }
      },
      onError(error) {
        alert(error);
      },
    },
  );
};

const useGetLocations = (
  subscriptionPlanId: string,
  name: string,
  enabled: boolean,
) => {
  return useInfiniteQuery(
    ["subscriptionLocations", subscriptionPlanId, name],
    async ({ pageParam = 1 }) => {
      const data = await SubscriptionsService.getLocations({
        subscription_plan_id: subscriptionPlanId,
        name: name || undefined,
        page: pageParam,
        per_page: 10,
      });
      return data;
    },
    {
      enabled: enabled && !!subscriptionPlanId,
      onError(error) {
        toast.error(getErrorMessage(error));
      },
      getNextPageParam: (lastPage: any) => {
        const currentPage = lastPage?.page || 1;
        const totalItems = lastPage?.total || 0;
        const perPage = lastPage?.per_page || 10;
        const totalPages = Math.ceil(totalItems / perPage);
        return currentPage < totalPages ? currentPage + 1 : undefined;
      },
    },
  );
};

const useUpdateInformation = (cb?: (data: any) => void) => {
  return useMutation(
    async (payload: {
      subscriptionId: string;
      data: { location_id?: string; user_email: string; user_phone: string };
    }) => {
      const data = await SubscriptionsService.updateInformation(
        payload.subscriptionId,
        payload.data,
      );
      return data;
    },
    {
      onSuccess: (data) => {
        cb?.(data);
        if (data.ok) {
          toast.success("Update subscription successfully!");
        } else {
          toast.error(data?.msg);
        }
      },
      onError(error) {
        toast.error(getErrorMessage(error));
      },
    },
  );
};

export {
  useGetList,
  useActive,
  usePayment,
  useDeActive,
  useDelete,
  useGetLocations,
  useUpdateInformation,
};
